import { render, staticRenderFns } from "./NftSwapList.vue?vue&type=template&id=0eda7e2e&scoped=true&"
import script from "./NftSwapList.vue?vue&type=script&lang=ts&"
export * from "./NftSwapList.vue?vue&type=script&lang=ts&"
import style0 from "./NftSwapList.vue?vue&type=style&index=0&id=0eda7e2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda7e2e",
  null
  
)

export default component.exports